import {observer} from "mobx-react-lite";
import clubStore from "../../../storage/ClubStore";
import Newbies from "./Newbies";
import TopDebts from './TopDebts'

const ManagerHome = () => {
    if (!clubStore.club?.is_manager) return null;
    return (
        <>
            <TopDebts/>
            <Newbies/>
        </>
    );
}

export default observer(ManagerHome);